<template>
  <div>
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {
    toPage() {
      this.$router.push("/user-center/user-setting/setting-phone");
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.user-setting {
  .portrait {
    margin-bottom: 30px;
    width: 89px;
    height: 89px;
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    margin-left: 495px;
    .upload {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: #000000;
      opacity: 0.2;
      z-index: 99;
      font-size: 16px;
      font-weight: 400;
      color: #ffffff;
      line-height: 89px;
      text-align: center;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .sysUser {
    .row {
      font-size: 20px;
      margin-left: 277px;
      .lable {
        margin-right: 12px;
        width: 60px;
        color: #909399;
      }
      .val {
        color: #999999;
        width: 436px;
        border-bottom: 2px solid #ececec;
        padding: 10px 20px 10px 20px;
      }
    }
  }
}
</style>
